import {Action} from "@ngrx/store";

export const LOAD_USER_LOCAL_STORAGE: string = '[user local storage] Load User Local Storage';
export const LOAD_USER_LOCAL_STORAGE_SUCCESS: string = '[user local storage] Load User Local Storage Success';
export const LOAD_USER_LOCAL_STORAGE_FAIL: string = '[user local storage] Load User Local Storage Fail';



export class LoadUserLocalStorage implements Action {

  readonly type: string = LOAD_USER_LOCAL_STORAGE;

}

export class LoadUserLocalStorageSuccess implements Action {

  readonly type: string = LOAD_USER_LOCAL_STORAGE_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadUserLocalStorageFail implements Action {

  readonly type: string = LOAD_USER_LOCAL_STORAGE_FAIL;
  constructor(public payload: string) {}

}

export type UserLocalStorageAction = LoadUserLocalStorage | LoadUserLocalStorageSuccess | LoadUserLocalStorageFail;
